angular.module('GlobalHelpersModule').filter "shortTimeLocal", ->
  (time) ->
    if time? then moment(time).format('h:mma') else ""